<script setup>
import { onMounted, ref } from 'vue'
import { ChevronUpIcon } from '@heroicons/vue/24/solid'

const showButton = ref(false)

const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    })
}

onMounted(() => {
    window.addEventListener('scroll', () => {
        if (window.scrollY > 150) {
            showButton.value = true
        } else {
            showButton.value = false
        }
    })
})
</script>

<template>
    <transition
        enter-active-class="ease-out duration-300"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="ease-in duration-300"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div
            v-show="showButton"
            class="fixed right-4 bottom-4 z-30"
        >
            <button
                @click="scrollToTop"
                class="faster-animation group relative size-16 rounded-full bg-red-500 p-4"
            >
                <ChevronUpIcon
                    class="faster-animation absolute top-1/2 left-1/2 size-8 -translate-x-1/2 -translate-y-1/2 text-white"
                />
            </button>
        </div>
    </transition>
</template>
